import React, { useState } from 'react';
import styles from './BigHome.module.css';
import homeImgs from '../../../assets/homeInfo/homeImgs';
import Modal from '../../../components/Modal/Modal';
import HomeDescriptionText from '../HomeDescriptionText';

const mainImg = {
  link: 'https://i.ibb.co/djLL5zf/4.jpg',
  alter: 'picture',
  year: '2021',
  size: '85 x 65 cm',
  status: 'For sale',
};

const BigHome = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setModalOpen(true);
    setSelectedImage(image);
    document.body.classList.add(styles['modal-open']);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalOpen(false);
    document.body.classList.remove(styles['modal-open']);
  };

  return (
    <div className={styles.main}>
      <HomeDescriptionText />

      <div
        className={styles.mainImgBox}
        onClick={() => {
          openModal(mainImg);
        }}
      >
        <img
          className={styles.mainImg}
          src="https://i.ibb.co/djLL5zf/4.jpg"
          // src="https://i.ibb.co/KbVGxtm/11.jpg"
          // src="https://i.ibb.co/rvFdmJD/architecture-3488306-1280.jpg"
          alt="1"
          border="0"
        />
      </div>
      <div className={styles.subImgContainer}>
        {homeImgs?.map((item, idx) => (
          <div
            className={styles.imgBox}
            key={idx}
            onClick={() => openModal(item)}
          >
            <img
              className={styles.img}
              src={item.link}
              alt={item.alter}
              border="0"
            />
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        selectedImage={selectedImage}
      />
    </div>
  );
};

export default BigHome;
